import { render, staticRenderFns } from "./ModalMakeOrder.vue?vue&type=template&id=0c86862b&scoped=true&"
import script from "./ModalMakeOrder.vue?vue&type=script&lang=js&"
export * from "./ModalMakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./ModalMakeOrder.vue?vue&type=style&index=0&id=0c86862b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c86862b",
  null
  
)

export default component.exports